import { FC } from 'react';
import { SwitchProps } from './switch.type';
import { Trans } from 'react-i18next';
import { getIdAttributes } from '../../utils/helper';

export const idPrefix: string = 'switch';

const Switch: FC<SwitchProps> = (props) => {
  const prefix: string = idPrefix;
  return (
    <div
      className={`flex items-center px-3 py-1.5 rounded-full cursor-pointer w-fit transition-colors duration-300 ${
        props.activeLabel ? 'bg-[#AEF21E]' : 'bg-gray-300'
      }`}
      onClick={() => props.onChangeSwitch(!props.activeLabel)}
      {...getIdAttributes(prefix, 'container')}
    >
      <span
        {...getIdAttributes(prefix, 'label')}
        className="text-black font-semibold text-sm mr-2"
      >
        {props.activeLabel ? (
          <Trans i18nKey={'userManagement.active'} />
        ) : (
          <Trans i18nKey={'userManagement.inActive'} />
        )}
      </span>
      <div
        {...getIdAttributes(prefix, 'thumb')}
        className={`w-5 h-5 rounded-full bg-white transition-transform duration-300 transform ${
          props.activeLabel ? 'translate-x-0' : 'translate-x-0'
        }`}
      ></div>
    </div>
  );
};

export default Switch;
